import axios from "axios";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  sendOTP,
  verifyOTP,
  setEmail,
  setOtp,
  setshowOtp,
  setError,
} from "../../store/auth";

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { showOtp, email, otp, isLoading, error, token } = useSelector(
    (state) => state.auth
  );
  // console.log(isLoading);

  // useEffect(() => {
  //   if (otp.length == 6) {
  //     dispatch(verifyOTP({ email, otp }));
  //   }
  //   return () => {};
  // }, [otp]);
  // useEffect(() => {
  //   setEmail("shantanu@modernizingprocesses.com");
  //   setOtp("631348");
  //   return () => {};
  // }, []);
  console.log(error);

  return (
    // <div className="login_page">
    //   <div className="login_main">
    //     <svg
    //       className="logo"
    //       xmlns="http://www.w3.org/2000/svg"
    //       width="334"
    //       height="109"
    //       viewBox="0 0 334 109"
    //       fill="none"
    //     >
    //       <g fill="var(--primary-base)" stroke="var(--primary-base)">
    //         <path d="M323 0C323.004 1.2314 323.007 2.46279 323.011 3.73151C323.048 15.3267 323.106 26.9217 323.184 38.5167C323.223 44.4781 323.256 50.4394 323.271 56.4009C323.286 62.1523 323.32 67.9033 323.368 73.6545C323.383 75.8505 323.391 78.0466 323.392 80.2427C323.394 83.3149 323.421 86.386 323.454 89.458C323.449 90.3693 323.444 91.2807 323.439 92.2197C323.494 97.2133 323.494 97.2133 325.831 101.518C328.441 103.301 330.962 104.171 334 105C334 105.33 334 105.66 334 106C321.79 106 309.58 106 297 106C297 105.34 297 104.68 297 104C298.093 103.752 299.186 103.505 300.312 103.25C304.294 101.9 305.107 101.601 307 98C307.275 95.0821 307.379 92.3829 307.341 89.4678C307.341 88.6089 307.341 87.75 307.342 86.8651C307.34 84.0296 307.316 81.1947 307.293 78.3594C307.287 76.3921 307.283 74.4248 307.28 72.4576C307.269 67.2822 307.239 62.1071 307.206 56.9319C307.175 51.6499 307.162 46.3679 307.146 41.0859C307.114 30.7238 307.063 20.3619 307 10C305.02 9.34 303.04 8.68 301 8C301 7.01 301 6.02 301 5C303.915 4.1603 306.832 3.32804 309.75 2.5C310.987 2.14229 310.987 2.14229 312.25 1.77734C313.449 1.43896 313.449 1.43896 314.672 1.09375C315.405 0.884277 316.138 0.674805 316.894 0.458984C319 0 319 0 323 0Z" />
    //         <path d="M222.449 38.5156C227.646 41.5403 230.948 44.8016 233.999 50C233.999 50.66 233.999 51.32 233.999 52C232.063 52.5043 230.125 53.0033 228.187 53.5C226.569 53.9176 226.569 53.9176 224.917 54.3437C221.999 55 221.999 55 218.999 55C218.943 54.0042 218.943 54.0042 218.886 52.9882C218.427 45.9847 218.427 45.9847 214.999 40C212.021 37.6832 208.799 37.5711 205.081 37.6953C199.569 38.502 196.123 41.5242 192.749 45.6875C185.8 55.8893 185.334 68.1741 187.585 80.1054C190.041 87.372 195.554 92.6941 202.304 96.1953C205.776 97.2317 209.094 97.383 212.687 97.375C213.746 97.3736 213.746 97.3736 214.827 97.3723C222.705 97.195 228.808 94.8666 234.999 90C234.355 95.5428 231.862 97.6094 227.703 101.062C218.146 107.912 208.422 109.255 196.999 108C187.178 105.771 179.53 99.7531 174.062 91.4375C168.195 81.8813 167.298 70.8651 169.652 59.9843C173.586 49.2467 180.947 42.162 190.999 37C201.323 32.8029 212.529 33.9696 222.449 38.5156Z" />
    //         <path d="M160.382 40.6132C164.489 43.9328 166.954 46.6436 167.999 51.9999C166.439 52.5087 164.876 53.0066 163.311 53.4999C162.441 53.7784 161.571 54.0568 160.675 54.3437C158.005 54.9984 155.735 55.1182 152.999 54.9999C153.045 54.4198 153.092 53.8398 153.139 53.2421C153.401 47.5876 152.816 44.471 148.999 39.9999C145.273 37.5158 142.314 37.4749 137.999 37.9999C130.141 40.9272 126.586 46.2673 123.014 53.4999C119.12 63.0868 120.231 73.9212 123.804 83.4023C126.722 89.7454 130.812 92.9629 136.999 95.9999C145.534 98.8261 155.939 97.8048 163.948 94.0702C164.625 93.717 165.302 93.3638 165.999 92.9999C166.748 92.6261 167.497 92.2523 168.268 91.8671C168.839 91.5809 169.411 91.2948 169.999 90.9999C168.301 97.4154 162.968 100.914 157.561 104.25C148.557 108.673 137.963 109.75 128.249 106.875C117.084 102.491 109.986 95.048 104.968 84.3359C103.777 81.465 103.189 79.1119 102.999 75.9999C102.937 75.2007 102.875 74.4015 102.811 73.578C102.368 63.7612 105.146 55.4048 111.37 47.7773C124.043 33.949 144.152 29.6251 160.382 40.6132Z" />
    //         <path
    //           fillRule="evenodd"
    //           clipRule="evenodd"
    //           d="M66.957 2.97136C66.7148 2.45208 66.4258 1.86468 66 0.999929C63 -7.10343e-05 63 -7.10343e-05 60.9141 0.345388L58.5508 0.996023L55.9844 1.68938L53.3125 2.43743C50.207 3.28289 47.1016 4.13201 44 4.99993V6.99993L47 8.99993C48.0156 11.8969 48.125 13.5512 47.293 16.5158L46.1094 19.2045L44.7812 22.2787L43.3047 25.5859L41.6211 29.455C40.8906 31.1335 40.1602 32.8112 39.4219 34.4867C37.5938 38.6359 35.793 42.7961 34.0117 46.9657C32.0508 51.559 30.082 56.1489 28.1016 60.7343L25.125 67.6249C23.6133 71.1496 22.1016 74.6745 20.5781 78.1952L19.1328 81.539C18.6367 82.704 18.1445 83.9311 17.6406 85.1886C15.0508 91.6362 12.1406 98.8815 6.54297 102.656L4.1875 103.5L1.79297 104.406L0 105V107H33L32 104L31.7656 103.973C27.8398 103.529 25.3789 103.251 22 101C21.3086 96.3598 22.1992 93.0666 23.8125 88.6874C25.5938 84.1066 27.1055 79.5173 28.4844 74.8007L29 72.9999C31.1367 72.9999 32.1328 72.9999 32.9805 72.9255C33.7227 72.8608 34.3516 72.7397 35.5273 72.5126L38.3672 71.8281L41.5352 71.0688L44.875 70.2499C53.2422 68.2219 61.5586 66.1025 69.8164 63.664L72 62.9999C72 63.6535 72 64.1132 72.0508 64.5671C72.1719 65.6428 72.5742 66.6869 73.9297 70.2053C74.5312 71.7477 75.168 73.3095 75.8125 74.8879C79.2266 83.2487 82.832 92.0763 82 101L73 105V107H116V105L112.312 103.812L110.238 103.144C103.742 99.8222 101.84 94.8964 99.3125 88.3354C98.4102 85.9147 97.4961 83.4987 96.5742 81.0864L94.3242 75.1699C92.7773 71.0588 91.2188 66.9523 89.6445 62.8515C85.4688 51.9772 81.2734 41.1083 77.2031 30.1918C76.0117 26.9792 74.8125 23.768 73.6055 20.559L71.875 15.9374C71.0664 13.7367 70.2578 11.5363 69.4336 9.34148L68.6797 7.33977C67.7617 4.86443 67.4688 4.07024 66.957 2.97136ZM54 15.9999H52C50.6758 19.6066 49.3008 23.1764 47.8477 26.7236C47.3242 28.0004 46.7891 29.2743 46.2461 30.5461L44.1875 35.3613L40.875 43.1249L39.1992 47.0348L37.543 50.9101L36.4922 53.3827C34.3828 58.2602 32.6094 62.664 32 67.9999C35.0859 67.9999 37.7031 67.3928 40.6758 66.6279L42.9492 66.0312L50.1797 64.1547L55.2109 62.8451L70 58.9999C69.2422 56.1398 68.7383 54.238 68.1562 52.3595C67.0039 48.6318 65.5508 44.9965 61.2188 34.1464L59.3906 29.5497L54 15.9999Z"
    //         />
    //         <path
    //           fillRule="evenodd"
    //           clipRule="evenodd"
    //           d="M299.998 52.0001C297.35 45.824 293.709 42.4527 287.998 39.0001C273.651 30.6949 257.557 34.4522 244.998 44.0001C238.276 50.5611 234.444 58.4642 233.69 67.8243C233.491 79.6832 236.209 88.6058 244.264 97.504C252.139 105.021 258.764 108.171 269.686 108.375C281.608 108.249 290.19 104.211 298.53 96.0001C299.108 95.2144 299.459 94.7374 299.67 94.2054C299.998 93.3831 299.998 92.429 299.998 90.0001C294.643 95.3541 288.596 97.2947 281.155 97.4937L278.748 97.5001C274.244 97.535 270.811 97.3409 266.616 95.5821C260.19 91.6998 256.229 87.5572 253.733 80.3516L252.748 76.6251C252.155 74.4195 251.565 72.212 250.998 70.0001C254.748 70.2173 258.034 69.6277 261.67 68.7049L263.827 68.1368L268.44 66.9473C270.838 66.3187 273.237 65.6902 275.639 65.0716C283.85 62.9625 292.002 60.8458 299.998 58.0001C300.104 56.9031 300.166 56.2757 300.182 55.647C300.202 54.8074 300.143 53.9659 299.998 52.0001ZM284.397 46.6563C283.791 42.6297 281.92 40.7371 278.811 38.2501C272.147 35.2879 266.514 36.6458 260.998 41.0001C253.623 48.5457 251.381 55.6319 250.998 66.0001C253.409 66.0001 253.409 66.0001 262.983 63.7071L266.936 62.7501L270.881 61.8399L274.651 60.9219C276.858 60.3968 277.662 60.2059 278.698 59.8536C279.287 59.6524 279.952 59.3987 280.998 59.0001C283.229 56.6729 283.916 55.5391 284.397 52.3438L284.373 49.5001L284.397 46.6563Z"
    //         />
    //       </g>
    //     </svg>

    //     <div className="login_email">
    //       <input
    //         value={email}
    //         type="text"
    //         placeholder="Email"
    //         onChange={(e) => {
    //           dispatch(setEmail(e.target.value.toLowerCase()));
    //         }}
    //       />
    //       <div
    //         className={
    //           "send_btn" +
    //           (/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email)
    //             ? " show"
    //             : "")
    //         }
    //         onClick={() => dispatch(sendOTP(email))}
    //       >
    //         {showOtp ? "Res" : "S"}end OTP
    //       </div>
    //     </div>

    //     <OTPInput
    //       {...{
    //         onChangeOTP: (otp_txt) => dispatch(setOtp(otp_txt)),
    //         className: "login_otp " + (showOtp ? "show" : ""),
    //       }}
    //     />
    //   </div>
    // </div>
    <div className="login_page_new">
      <div className="login_page_section">
        <svg
          className="logo"
          xmlns="http://www.w3.org/2000/svg"
          width="334"
          height="109"
          viewBox="0 0 334 109"
          fill="none"
        >
          <g fill="var(--primary-base)" stroke="var(--primary-base)">
            <path d="M323 0C323.004 1.2314 323.007 2.46279 323.011 3.73151C323.048 15.3267 323.106 26.9217 323.184 38.5167C323.223 44.4781 323.256 50.4394 323.271 56.4009C323.286 62.1523 323.32 67.9033 323.368 73.6545C323.383 75.8505 323.391 78.0466 323.392 80.2427C323.394 83.3149 323.421 86.386 323.454 89.458C323.449 90.3693 323.444 91.2807 323.439 92.2197C323.494 97.2133 323.494 97.2133 325.831 101.518C328.441 103.301 330.962 104.171 334 105C334 105.33 334 105.66 334 106C321.79 106 309.58 106 297 106C297 105.34 297 104.68 297 104C298.093 103.752 299.186 103.505 300.312 103.25C304.294 101.9 305.107 101.601 307 98C307.275 95.0821 307.379 92.3829 307.341 89.4678C307.341 88.6089 307.341 87.75 307.342 86.8651C307.34 84.0296 307.316 81.1947 307.293 78.3594C307.287 76.3921 307.283 74.4248 307.28 72.4576C307.269 67.2822 307.239 62.1071 307.206 56.9319C307.175 51.6499 307.162 46.3679 307.146 41.0859C307.114 30.7238 307.063 20.3619 307 10C305.02 9.34 303.04 8.68 301 8C301 7.01 301 6.02 301 5C303.915 4.1603 306.832 3.32804 309.75 2.5C310.987 2.14229 310.987 2.14229 312.25 1.77734C313.449 1.43896 313.449 1.43896 314.672 1.09375C315.405 0.884277 316.138 0.674805 316.894 0.458984C319 0 319 0 323 0Z" />
            <path d="M222.449 38.5156C227.646 41.5403 230.948 44.8016 233.999 50C233.999 50.66 233.999 51.32 233.999 52C232.063 52.5043 230.125 53.0033 228.187 53.5C226.569 53.9176 226.569 53.9176 224.917 54.3437C221.999 55 221.999 55 218.999 55C218.943 54.0042 218.943 54.0042 218.886 52.9882C218.427 45.9847 218.427 45.9847 214.999 40C212.021 37.6832 208.799 37.5711 205.081 37.6953C199.569 38.502 196.123 41.5242 192.749 45.6875C185.8 55.8893 185.334 68.1741 187.585 80.1054C190.041 87.372 195.554 92.6941 202.304 96.1953C205.776 97.2317 209.094 97.383 212.687 97.375C213.746 97.3736 213.746 97.3736 214.827 97.3723C222.705 97.195 228.808 94.8666 234.999 90C234.355 95.5428 231.862 97.6094 227.703 101.062C218.146 107.912 208.422 109.255 196.999 108C187.178 105.771 179.53 99.7531 174.062 91.4375C168.195 81.8813 167.298 70.8651 169.652 59.9843C173.586 49.2467 180.947 42.162 190.999 37C201.323 32.8029 212.529 33.9696 222.449 38.5156Z" />
            <path d="M160.382 40.6132C164.489 43.9328 166.954 46.6436 167.999 51.9999C166.439 52.5087 164.876 53.0066 163.311 53.4999C162.441 53.7784 161.571 54.0568 160.675 54.3437C158.005 54.9984 155.735 55.1182 152.999 54.9999C153.045 54.4198 153.092 53.8398 153.139 53.2421C153.401 47.5876 152.816 44.471 148.999 39.9999C145.273 37.5158 142.314 37.4749 137.999 37.9999C130.141 40.9272 126.586 46.2673 123.014 53.4999C119.12 63.0868 120.231 73.9212 123.804 83.4023C126.722 89.7454 130.812 92.9629 136.999 95.9999C145.534 98.8261 155.939 97.8048 163.948 94.0702C164.625 93.717 165.302 93.3638 165.999 92.9999C166.748 92.6261 167.497 92.2523 168.268 91.8671C168.839 91.5809 169.411 91.2948 169.999 90.9999C168.301 97.4154 162.968 100.914 157.561 104.25C148.557 108.673 137.963 109.75 128.249 106.875C117.084 102.491 109.986 95.048 104.968 84.3359C103.777 81.465 103.189 79.1119 102.999 75.9999C102.937 75.2007 102.875 74.4015 102.811 73.578C102.368 63.7612 105.146 55.4048 111.37 47.7773C124.043 33.949 144.152 29.6251 160.382 40.6132Z" />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M66.957 2.97136C66.7148 2.45208 66.4258 1.86468 66 0.999929C63 -7.10343e-05 63 -7.10343e-05 60.9141 0.345388L58.5508 0.996023L55.9844 1.68938L53.3125 2.43743C50.207 3.28289 47.1016 4.13201 44 4.99993V6.99993L47 8.99993C48.0156 11.8969 48.125 13.5512 47.293 16.5158L46.1094 19.2045L44.7812 22.2787L43.3047 25.5859L41.6211 29.455C40.8906 31.1335 40.1602 32.8112 39.4219 34.4867C37.5938 38.6359 35.793 42.7961 34.0117 46.9657C32.0508 51.559 30.082 56.1489 28.1016 60.7343L25.125 67.6249C23.6133 71.1496 22.1016 74.6745 20.5781 78.1952L19.1328 81.539C18.6367 82.704 18.1445 83.9311 17.6406 85.1886C15.0508 91.6362 12.1406 98.8815 6.54297 102.656L4.1875 103.5L1.79297 104.406L0 105V107H33L32 104L31.7656 103.973C27.8398 103.529 25.3789 103.251 22 101C21.3086 96.3598 22.1992 93.0666 23.8125 88.6874C25.5938 84.1066 27.1055 79.5173 28.4844 74.8007L29 72.9999C31.1367 72.9999 32.1328 72.9999 32.9805 72.9255C33.7227 72.8608 34.3516 72.7397 35.5273 72.5126L38.3672 71.8281L41.5352 71.0688L44.875 70.2499C53.2422 68.2219 61.5586 66.1025 69.8164 63.664L72 62.9999C72 63.6535 72 64.1132 72.0508 64.5671C72.1719 65.6428 72.5742 66.6869 73.9297 70.2053C74.5312 71.7477 75.168 73.3095 75.8125 74.8879C79.2266 83.2487 82.832 92.0763 82 101L73 105V107H116V105L112.312 103.812L110.238 103.144C103.742 99.8222 101.84 94.8964 99.3125 88.3354C98.4102 85.9147 97.4961 83.4987 96.5742 81.0864L94.3242 75.1699C92.7773 71.0588 91.2188 66.9523 89.6445 62.8515C85.4688 51.9772 81.2734 41.1083 77.2031 30.1918C76.0117 26.9792 74.8125 23.768 73.6055 20.559L71.875 15.9374C71.0664 13.7367 70.2578 11.5363 69.4336 9.34148L68.6797 7.33977C67.7617 4.86443 67.4688 4.07024 66.957 2.97136ZM54 15.9999H52C50.6758 19.6066 49.3008 23.1764 47.8477 26.7236C47.3242 28.0004 46.7891 29.2743 46.2461 30.5461L44.1875 35.3613L40.875 43.1249L39.1992 47.0348L37.543 50.9101L36.4922 53.3827C34.3828 58.2602 32.6094 62.664 32 67.9999C35.0859 67.9999 37.7031 67.3928 40.6758 66.6279L42.9492 66.0312L50.1797 64.1547L55.2109 62.8451L70 58.9999C69.2422 56.1398 68.7383 54.238 68.1562 52.3595C67.0039 48.6318 65.5508 44.9965 61.2188 34.1464L59.3906 29.5497L54 15.9999Z"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M299.998 52.0001C297.35 45.824 293.709 42.4527 287.998 39.0001C273.651 30.6949 257.557 34.4522 244.998 44.0001C238.276 50.5611 234.444 58.4642 233.69 67.8243C233.491 79.6832 236.209 88.6058 244.264 97.504C252.139 105.021 258.764 108.171 269.686 108.375C281.608 108.249 290.19 104.211 298.53 96.0001C299.108 95.2144 299.459 94.7374 299.67 94.2054C299.998 93.3831 299.998 92.429 299.998 90.0001C294.643 95.3541 288.596 97.2947 281.155 97.4937L278.748 97.5001C274.244 97.535 270.811 97.3409 266.616 95.5821C260.19 91.6998 256.229 87.5572 253.733 80.3516L252.748 76.6251C252.155 74.4195 251.565 72.212 250.998 70.0001C254.748 70.2173 258.034 69.6277 261.67 68.7049L263.827 68.1368L268.44 66.9473C270.838 66.3187 273.237 65.6902 275.639 65.0716C283.85 62.9625 292.002 60.8458 299.998 58.0001C300.104 56.9031 300.166 56.2757 300.182 55.647C300.202 54.8074 300.143 53.9659 299.998 52.0001ZM284.397 46.6563C283.791 42.6297 281.92 40.7371 278.811 38.2501C272.147 35.2879 266.514 36.6458 260.998 41.0001C253.623 48.5457 251.381 55.6319 250.998 66.0001C253.409 66.0001 253.409 66.0001 262.983 63.7071L266.936 62.7501L270.881 61.8399L274.651 60.9219C276.858 60.3968 277.662 60.2059 278.698 59.8536C279.287 59.6524 279.952 59.3987 280.998 59.0001C283.229 56.6729 283.916 55.5391 284.397 52.3438L284.373 49.5001L284.397 46.6563Z"
            />
          </g>
        </svg>
        <div className="login_page_title">
          {showOtp ? "Check your email" : "Login"}
        </div>
        <div className="login_page_desc">
          {showOtp
            ? `We've sent a pin to ${email}`
            : "Please enter your email address"}
        </div>
        {showOtp ? (
          <>
            <div className="login_email">
              <input
                value={otp}
                type="text"
                placeholder="000000"
                onChange={(e) => {
                  dispatch(setOtp(e.target.value.toLowerCase()));
                  dispatch(setError(false));
                }}
              />
            </div>
            {error?.error ? <div className="error">Wrong passcode</div> : ""}
            <div
              className={"send_email " + (otp?.length > 0 ? " show" : "")}
              onClick={() => {
                // dispatch(setOtp(otp));
                if (otp?.length > 0) {
                  dispatch(verifyOTP({ email, otp }));
                }
              }}
            >
              Sign In
            </div>
            <div
              className="need_other"
              onClick={() => {
                dispatch(setshowOtp(false));
              }}
            >
              I need another pin
            </div>
          </>
        ) : (
          <>
            <div className="login_email">
              <input
                value={email}
                type="text"
                placeholder="Enter your email"
                onChange={(e) => {
                  dispatch(setEmail(e.target.value.toLowerCase()));
                  dispatch(setError(false));
                }}
              />
            </div>
            {error?.message ? (
              <div className="error">
                {error?.error?._message || "User not exist"}
              </div>
            ) : (
              ""
            )}
            <div
              className={
                "send_email" +
                (/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(
                  email
                ) && !isLoading
                  ? " show"
                  : "")
              }
              onClick={() => {
                if (
                  /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email)
                ) {
                  dispatch(sendOTP(email));
                }
              }}
            >
              {isLoading ? "Sending pin..." : "Continue"}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Login;
const OTPInput = ({ length = 6, onChangeOTP, className }) => {
  const [otp, setOtp] = useState(new Array(length).fill(""));
  const handleChange = (element, index) => {
    const value = element.value;

    // Detect if the pasted value is longer than 1 character
    if (value.length == 6) {
      const newOtp = [...otp];
      for (let i = 0; i < value.length; i++) {
        if (index + i < length) {
          newOtp[index + i] = value[i];
        }
      }
      setOtp(newOtp);
      onChangeOTP(newOtp.join(""));
      return;
    }

    if (isNaN(value)) return; // Ignore non-numeric input

    let newOtp = [...otp];
    newOtp[index] = value.slice(-1);
    setOtp(newOtp);

    // Automatically focus next input if present
    if (value !== "" && element.nextSibling) {
      element.nextSibling.focus();
    }

    onChangeOTP(newOtp.join(""));
  };

  const handleKeyDown = (event, index) => {
    if (event.key === "Backspace" && !otp[index] && index > 0) {
      event.target.previousSibling.focus();
    }
    console.log(event.key);

    // write case for arrowLeft
    if (event.key === "ArrowLeft" && index > 0) {
      event.target.previousSibling.focus();
    }
    // write case for arrowRight
    if (event.key === "ArrowRight" && index < length - 1) {
      event.target.nextSibling.focus();
    }
    // write case for tab
    if (event.key === "Tab") {
      event.preventDefault();
      if (index < length - 1) {
        event.target.nextSibling.focus();
      } else {
        event.target.parentNode.firstChild.focus();
      }
    }
  };

  return (
    <div
      className={"otp_flex " + className}
      style={{
        "--total": length,
      }}
    >
      {otp.map((_, index) => (
        <input
          key={index}
          type="text"
          maxLength="1"
          value={otp[index]}
          style={{
            // "--index": Math.abs(
            //   (index < middle ? middle - 1 : 0) - (index % middle),
            "--index": index,
          }}
          onChange={(e) => handleChange(e.target, index)}
          onKeyDown={(e) => handleKeyDown(e, index)}
          onPaste={(e) => handleChange(e.target, index)}
        />
      ))}
    </div>
  );
};
